import {DATA_TABLE_PAYLOAD} from '../Types/types'

export function storeDataTablePayload(data: any) {
  return {
    type: DATA_TABLE_PAYLOAD,
    payload: data
  }
}
